/**
 * Discount Banner
 * Zeigt NUR cart-weite Rabatt-Banner auf Produktseiten:
 * - Gutscheincodes im Cart (auch bei leerem Warenkorb) ✅
 * - Cart-Level Discounts (kundenspezifische Rabatte) ✅
 * - Line-Level Discounts die in AUTO_DISCOUNT_MAPPING sind (cart-weit) ✅
 * NICHT: Artikel-spezifische Line-Level Discounts ❌
 */

const DiscountBanner = (function() {
  'use strict';
  
  const DISCOUNT_CONFIGS = {
    'AA80D8MZPJ7E': {
      headline: '10% Newsletter-Rabatt aktiviert',
      text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen.',
      color: 'purple',
      tooltip: 'Rabatte sind nur für Bestellungen mit der zum Newsletter angemeldeten E-Mail Adresse gültig',
      isPattern: false
    },
    '1223D8MZPJ7E': {
      headline: '12% Newsletter-Rabatt aktiviert',
      text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen.',
      color: 'purple',
      tooltip: 'Rabatte sind nur für Bestellungen mit der zum Newsletter angemeldeten E-Mail Adresse gültig',
      isPattern: false
    },
    '10NL1125': {
      headline: '10% Newsletter-Rabatt aktiviert',
      text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen.',
      color: 'purple',
      tooltip: 'Rabatte sind nur für Bestellungen mit der zum Newsletter angemeldeten E-Mail Adresse gültig',
      isPattern: true,
      patternRegex: '^10NL1125'
    },
    '3NL1125': {
      headline: '3% Newsletter-Rabatt aktiviert',
      text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen.',
      color: 'green',
      tooltip: 'Rabatte sind nur für Bestellungen mit der zum Newsletter angemeldeten E-Mail Adresse gültig',
      isPattern: true,
      patternRegex: '^3NL1125'
    },
    'EA': {
      headline: '15% Osterrabatt aktiviert',
      text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen. Gültig bis zum 07.04.26.',
      color: 'gold',
      tooltip: 'Rabatte sind nur für Bestellungen mit der zum Newsletter angemeldeten E-Mail Adresse gültig',
      isPattern: true,
      patternRegex: '^EA'
    }
  };
  
  const AUTO_DISCOUNT_MAPPING = {
    '10% Newsletter-Welcome': {
      headline: '10% Newsletter-Rabatt aktiviert',
      text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen.',
      color: 'purple',
      tooltip: 'Rabatte sind nur für Bestellungen mit der zum Newsletter angemeldeten E-Mail Adresse gültig'
    },
    '3% Newsletter-Member': {
      headline: '3% Newsletter-Member-Rabatt aktiviert',
      text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen.',
      color: 'green',
      tooltip: 'Rabatte sind nur für Bestellungen mit der zum Newsletter angemeldeten E-Mail Adresse gültig'
    },
    '15% Osterrabatt-Newsletter-Member': {
      headline: '15% Osterrabatt aktiviert',
      text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen.',
      color: 'gold',
      tooltip: 'Rabatte sind nur für Bestellungen mit der zum Newsletter angemeldeten E-Mail Adresse gültig'
    }
  };
  
  const DEFAULT_CONFIG = {
    headline: 'Rabatt aktiviert',
    text: 'Ihr exklusiver Rabatt wird automatisch im Warenkorb abgezogen.',
    color: 'purple',
    tooltip: 'Dieser Rabatt wird automatisch auf Ihre Bestellung angewendet',
    isPattern: false
  };
  
  const ICONS = {
    discount: '<svg aria-hidden="true" focusable="false" fill="none" width="20" class="icon icon-discount" viewBox="0 0 24 24"><path d="M22.707 12.293l-11-11A1.002 1.002 0 0 0 11 1H2a1 1 0 0 0-1 1v9c0 .265.105.52.293.707l11 11a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414zM7 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 9zm6 8.414L8.586 13 10 11.586 14.414 16 13 17.414zm3-3L11.586 10 13 8.586 17.414 13 16 14.414z" fill="currentColor"></path></svg>',
    info: '<svg aria-hidden="true" focusable="false" width="18" class="shrink-0 icon icon-picto-info" viewBox="0 0 24 24"><path vector-effect="non-scaling-stroke" d="M1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12Z" fill="none" stroke="currentColor" stroke-width="1.4"></path><path vector-effect="non-scaling-stroke" d="M8 10H12V17" fill="none" stroke="currentColor" stroke-width="1.4"></path><path vector-effect="non-scaling-stroke" d="M8 17H16" fill="none" stroke="currentColor" stroke-width="1.4"></path><path vector-effect="non-scaling-stroke" d="M12 7V5" fill="none" stroke="currentColor" stroke-width="1.4"></path></svg>'
  };
  
  function fetchCartData() {
    var timestamp = new Date().getTime();
    return fetch('/cart.js?t=' + timestamp, {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    })
      .then(function(response) {
        return response.json();
      })
      .catch(function(error) {
        console.error('Error fetching cart:', error);
        return null;
      });
  }
  
  function extractDiscountFromCart(cart) {
    if (!cart) {
      return null;
    }
    
    // 1. Discount Codes (auch bei leerem Warenkorb) - CART-WEIT ✅
    if (cart.discount_codes && Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0) {
      var discountCode = null;
      
      for (var i = 0; i < cart.discount_codes.length; i++) {
        if (cart.discount_codes[i].applicable) {
          discountCode = cart.discount_codes[i];
          break;
        }
      }
      
      if (!discountCode) {
        discountCode = cart.discount_codes[cart.discount_codes.length - 1];
      }
      
      return {
        code: discountCode.code,
        source: 'discount_codes',
        applicable: discountCode.applicable
      };
    }
    
    // 2. Cart Level Discounts - CART-WEIT ✅
    if (cart.cart_level_discount_applications && 
        Array.isArray(cart.cart_level_discount_applications) && 
        cart.cart_level_discount_applications.length > 0) {
      
      var discount = cart.cart_level_discount_applications[0];
      
      return {
        code: discount.title,
        source: 'cart_level_discount'
      };
    }
    
    // 3. Line Level Discounts - NUR wenn in AUTO_DISCOUNT_MAPPING (cart-weit) ✅
    if (cart.items && Array.isArray(cart.items) && cart.items.length > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        
        if (item.line_level_discount_allocations && 
            Array.isArray(item.line_level_discount_allocations) && 
            item.line_level_discount_allocations.length > 0) {
          
          var allocation = item.line_level_discount_allocations[0];
          var discountApp = allocation.discount_application;
          
          if (discountApp && discountApp.title) {
            var title = discountApp.title;
            
            if (AUTO_DISCOUNT_MAPPING[title]) {
              return {
                code: title,
                source: 'line_level_discount_cart_wide'
              };
            }
          }
        }
      }
    }
    
    // 4. Cart Attributes - CART-WEIT ✅
    if (cart.attributes && 
        cart.attributes.discount_code && 
        cart.attributes.discount_code !== '' && 
        cart.attributes.discount_code !== null) {
      
      return {
        code: cart.attributes.discount_code,
        source: 'cart_attributes'
      };
    }
    
    return null;
  }
  
  function getConfig(info) {
    // Automatische cart-weite Rabatte (von cart_level_discount oder line_level_discount_cart_wide)
    if ((info.source === 'cart_level_discount' || info.source === 'line_level_discount_cart_wide') && info.code) {
      if (AUTO_DISCOUNT_MAPPING[info.code]) {
        return formatConfig(AUTO_DISCOUNT_MAPPING[info.code]);
      }
      
      return formatConfig(DEFAULT_CONFIG);
    }
    
    // Gutscheincodes (discount_codes oder cart_attributes)
    var code = info.code.toUpperCase();
    
    // Exakte Matches
    if (DISCOUNT_CONFIGS[code]) {
      return formatConfig(DISCOUNT_CONFIGS[code]);
    }
    
    // Pattern Matches
    for (var key in DISCOUNT_CONFIGS) {
      if (DISCOUNT_CONFIGS.hasOwnProperty(key)) {
        var config = DISCOUNT_CONFIGS[key];
        
        if (config.isPattern && config.patternRegex) {
          var regex = new RegExp(config.patternRegex, 'i');
          
          if (regex.test(code)) {
            return formatConfig(config);
          }
        }
      }
    }
    
    return formatConfig(DEFAULT_CONFIG);
  }
  
  function formatConfig(config) {
    return {
      headline: config.headline,
      text: config.text,
      color: config.color,
      tooltip: config.tooltip
    };
  }
  
  function renderBanner(info) {
    var container = document.getElementById('discount-banner-container');
    if (!container) {
      // Kein Banner-Container auf dieser Seite (z.B. Collection-Pages) — still beenden
      return;
    }
    
    var config = getConfig(info);
    
    container.innerHTML = 
      '<div class="discount-banner discount-banner--' + config.color + '">' +
        '<div class="discount-banner__content">' +
          '<div class="discount-banner__icon">' + ICONS.discount + '</div>' +
          '<div class="discount-banner__text">' +
            '<div class="discount-banner__headline-wrapper">' +
              '<p class="discount-banner__headline">' + config.headline + '</p>' +
              '<div class="discount-banner__info-wrapper">' +
                '<button type="button" class="discount-banner__info" aria-label="Info">' +
                  ICONS.info +
                '</button>' +
                '<div class="discount-banner__tooltip">' + config.tooltip + '</div>' +
              '</div>' +
            '</div>' +
            '<p class="discount-banner__description">' + config.text + '</p>' +
          '</div>' +
        '</div>' +
      '</div>';
    
    var infoBtn = container.querySelector('.discount-banner__info');
    var tooltip = container.querySelector('.discount-banner__tooltip');
    
    if (infoBtn && tooltip) {
      infoBtn.addEventListener('mouseenter', function() {
        tooltip.classList.add('discount-banner__tooltip--visible');
      });
      
      infoBtn.addEventListener('mouseleave', function() {
        tooltip.classList.remove('discount-banner__tooltip--visible');
      });
      
      infoBtn.addEventListener('click', function(e) {
        e.preventDefault();
        tooltip.classList.toggle('discount-banner__tooltip--visible');
      });
      
      document.addEventListener('click', function(e) {
        if (!infoBtn.contains(e.target) && !tooltip.contains(e.target)) {
          tooltip.classList.remove('discount-banner__tooltip--visible');
        }
      });
    }
    
    container.style.display = 'block';
  }
  
  function hideBanner() {
    var container = document.getElementById('discount-banner-container');
    if (container) {
      container.style.display = 'none';
      container.innerHTML = '';
    }
  }
  
  let lastRenderedCode = null;
  let pollInterval = null;
  
  function extractDiscountFromURL() {
    var pathname = window.location.pathname;
    var match = pathname.match(/\/discount\/([A-Z0-9]+)/i);
    if (match) {
      return match[1];
    }
    return null;
  }
  
  function startPolling() {
    var urlCode = extractDiscountFromURL();
    if (!urlCode) return;
    
    var attempts = 0;
    var maxAttempts = 5;
    
    if (pollInterval) clearInterval(pollInterval);
    
    pollInterval = setInterval(function() {
      attempts++;
      
      fetchCartData().then(function(cart) {
        var info = extractDiscountFromCart(cart);
        
        var codeMatches = false;
        if (info) {
          var cartCode = info.code.toUpperCase();
          var urlCodeUpper = urlCode.toUpperCase();
          
          if (cartCode === urlCodeUpper) {
            codeMatches = true;
          } else if (cartCode.indexOf(urlCodeUpper) === 0) {
            codeMatches = true;
          } else if (urlCodeUpper.indexOf(cartCode) === 0) {
            codeMatches = true;
          }
        }
        
        if (codeMatches) {
          clearInterval(pollInterval);
          pollInterval = null;
          
          if (lastRenderedCode !== info.code) {
            lastRenderedCode = info.code;
            renderBanner(info);
          }
        } else if (attempts >= maxAttempts) {
          clearInterval(pollInterval);
          pollInterval = null;
        }
      });
    }, 400);
  }
  
  function init() {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
    
    fetchCartData().then(function(cart) {
      var info = extractDiscountFromCart(cart);
      
      if (info) {
        if (lastRenderedCode !== info.code) {
          lastRenderedCode = info.code;
          renderBanner(info);
        }
      } else {
        if (lastRenderedCode !== null) {
          lastRenderedCode = null;
          hideBanner();
        }
      }
    });
    
    startPolling();
  }
  
  return {
    init: init,
    refresh: init
  };
})();

// Initialisierung
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', DiscountBanner.init);
} else {
  DiscountBanner.init();
}

// Event Listeners für Cart Updates
// Stretch feuert cart:change und cart:refresh. cart:updated bleibt für
// Fremdaufrufe bestehen, wird vom Theme selbst aber nicht ausgelöst.
['cart:change', 'cart:refresh', 'cart:updated'].forEach(function(eventName) {
  document.addEventListener(eventName, function() {
    DiscountBanner.refresh();
  });
});

// Shopify Theme Events
document.addEventListener('shopify:section:load', function() {
  setTimeout(DiscountBanner.refresh, 100);
});

document.addEventListener('shopify:section:reorder', function() {
  setTimeout(DiscountBanner.refresh, 100);
});